import React, { useState } from 'react'

function SettleUp({ balance, onSettle, disabled, couple, currentUserId }) {
  const [isSettling, setIsSettling] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)

  const handleSettleClick = () => {
    if (balance === 0) return
    setShowConfirm(true)
  }

  const handleConfirm = async () => {
    setIsSettling(true)
    try {
      await onSettle()
      setShowConfirm(false)
    } catch (error) {
      console.error('Error settling:', error)
    } finally {
      setIsSettling(false)
    }
  }

  const handleCancel = () => {
    setShowConfirm(false)
  }

  if (balance === 0) {
    return null
  }

  const absBalance = Math.abs(balance).toFixed(2)
  const partnerName =
    couple?.members?.find((member) => member.user_id !== currentUserId)?.display_name || "Partner";
  const settleText = balance > 0
    ? `${partnerName} pays you $${absBalance}`
    : `You pay ${partnerName} $${absBalance}`

  return (
    <div className="settle-up">
      {!showConfirm ? (
        <button
          className="settle-btn"
          onClick={handleSettleClick}
          disabled={disabled || balance === 0}
        >
          Settle Up
        </button>
      ) : (
        <div className="settle-confirm">
          <p>{settleText}</p>
          <div className="settle-actions">
            <button
              className="confirm-btn"
              onClick={handleConfirm}
              disabled={isSettling}
            >
              {isSettling ? 'Settling...' : 'Confirm'}
            </button>
            <button
              className="cancel-btn"
              onClick={handleCancel}
              disabled={isSettling}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default SettleUp
